import { render, staticRenderFns } from "./MobileTableCityPrices.vue?vue&type=template&id=0c62963f&scoped=true&"
import script from "./MobileTableCityPrices.vue?vue&type=script&lang=js&"
export * from "./MobileTableCityPrices.vue?vue&type=script&lang=js&"
import style0 from "./MobileTableCityPrices.vue?vue&type=style&index=0&id=0c62963f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c62963f",
  null
  
)

export default component.exports